import { ComputerDesktopIcon, MoonIcon, SunIcon } from '@heroicons/react/24/outline';

import { useTheme } from '../theme/ThemeProvider';
import type { ThemeChoice } from '../theme/ThemeProvider';

const OPTIONS: { choice: ThemeChoice; label: string; Icon: typeof MoonIcon }[] = [
  { choice: 'dark', label: 'Dark', Icon: MoonIcon },
  { choice: 'light', label: 'Light', Icon: SunIcon },
  { choice: 'system', label: 'System', Icon: ComputerDesktopIcon },
];

/**
 * Tri-state, not a switch.
 *
 * A two-state toggle cannot express "follow my system", and collapsing the three into two
 * means a user who wants to follow the OS has no way to say so.
 */
export function ThemeToggle() {
  const { choice, setChoice } = useTheme();

  return (
    <div
      role="group"
      aria-label="Colour theme"
      className="inline-flex overflow-hidden rounded-lg border border-line-strong"
    >
      {OPTIONS.map(({ choice: option, label, Icon }) => {
        const active = choice === option;
        return (
          <button
            key={option}
            type="button"
            // `aria-pressed` rather than `aria-current`: this is a set of toggles, and a
            // screen reader should say which one is on.
            aria-pressed={active}
            aria-label={label}
            title={`${label} theme`}
            onClick={() => setChoice(option)}
            className={`p-1.5 transition-colors ${
              active
                ? 'bg-brand text-on-brand'
                : 'bg-surface text-muted hover:bg-raised hover:text-body'
            }`}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
